// extracted by mini-css-extract-plugin
export var container = "HeaderTemplate-module--container--6ef3b";
export var image = "HeaderTemplate-module--image--2c1c9";
export var languageSelect = "HeaderTemplate-module--languageSelect--17168";
export var languageSelectContainer = "HeaderTemplate-module--languageSelectContainer--9c336";
export var languageSelectDisabled = "HeaderTemplate-module--languageSelectDisabled--65e3c";
export var navContainer = "HeaderTemplate-module--navContainer--2739d";
export var skipLinkContainer = "HeaderTemplate-module--skipLinkContainer--89113";